import { Grid } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import Appointments from "./Appointments";
import DailySales from "./DailySales";

const tabs = [
  { label: "Daily sales summary", value: "summary" },
  { label: "Appointments", value: "salesAppointments" },
];

function ClientSales() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Functions

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, sales: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Sales*"}
            tabs={tabs}
            activeTab={activeTab.sales}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.sales === "summary" ? <DailySales /> : <Appointments />}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default ClientSales;
